import React, { useState } from 'react'
import ShopHeader from './ShopHeader'
import { setData } from './Med';

const Items = () => {

    const [count, setCount] = useState(0);

    const add = (obj) => {
        setData(obj);
        setCount(count + 1);
    }


    return (
        <>
            <ShopHeader cartCount={count} />
            <i><h1 className='h1t'>DAILY ITEMS</h1></i>

            <div className='row'>
                {itemData.map((items) => {
                    return (
                        <div class="card cardstyle">
                            <img class="card-img-top mt-2" src={items.img} alt="Card  cap" />
                            <div class="card-body">
                                <h5 class="card-title">{items.title}</h5>
                                <button onClick={() => add(items)} class="btn btn-primary">
                                    Add to Cart</button>
                            </div>
                        </div>
                    )
                })}

            </div>
        </>
    )
}
const itemData = [
    {
        img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
        title: 'Camera',
    },
    {
        img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
        title: 'Hats',
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
        title: 'Basketball',
    },
    {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        author: '@southside_customs',
        cols: 2,
    },
];

export default Items;